(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery-reworked"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reworked-product-gallery')) {
    customElements.define(
      'reworked-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleGalleryClick);
          this.variantEventTarget = this.closest('.shopify-section, dialog');
          this.variantEventTarget?.addEventListener('variant:update', this.handleVariantUpdate);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleGalleryClick);
          this.variantEventTarget?.removeEventListener('variant:update', this.handleVariantUpdate);
        }

        handleGalleryClick(event) {
          const target = event.target instanceof Element ? event.target : null;
          const button = target?.closest('.reworked-product-gallery__thumbnail[data-gallery-index]');
          if (!button || !this.contains(button)) return;
          this.selectSlide(button.dataset.galleryIndex);
        }

        handleVariantUpdate = (event) => {
          const { resource, data } = event.detail ?? {};
          if (data?.productId && data.productId !== this.dataset.productId) return;

          const mediaId = resource?.featured_media?.id;
          if (mediaId) {
            const slide = this.querySelector(`[data-gallery-media-id="${mediaId}"]`);
            if (slide) this.selectSlide(slide.dataset.gallerySlide);
          }
        };

        selectSlide(activeIndex) {
          this.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
            const isActive = slide.dataset.gallerySlide === activeIndex;
            slide.hidden = !isActive;
            slide.setAttribute('aria-hidden', String(!isActive));
            if (!isActive) {
              slide.querySelectorAll('video').forEach((video) => video.pause());
            }
          });

          this.querySelectorAll('[data-gallery-index]').forEach((thumbnail) => {
            const isActive = thumbnail.dataset.galleryIndex === activeIndex;
            thumbnail.setAttribute('aria-pressed', String(isActive));
            thumbnail.classList.toggle('is-active', isActive);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
